module.exports = [
  'Promise',
  function (Promise) {
    return {
      listSharedAccessMailbox: Promise.wrapper('mbox:listSharedAccessMbox'),
      setSharedAccessMboxVisible: Promise.wrapper('mbox:setSharedAccessMboxVisible')
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/setting/sharedMailbox/sharedMailboxService.js